import { Injectable } from '@angular/core';
import { PedidoItem } from '../item';
import { toFixed } from '../../../core/services/utils/numbers';
import { PedidoItemPesoValueObject } from '../item/domain';

@Injectable({
    providedIn: 'root'
})
export class PedidoPesosService {

    /** Calcula os pesos do pedido somando os pesos de seus itens */
    calcularPesos(pedidoItens: PedidoItem[]): {pesoBruto: number, pesoLiquido: number} {
        let pesoBruto = 0;
        let pesoLiquido = 0;
        pedidoItens?.forEach(pedidoItem => {
            // Peso Bruto
            const voPesoBruto = new PedidoItemPesoValueObject(pedidoItem.quantidade, pedidoItem.pesoBrutoUnitario);
            pesoBruto += voPesoBruto.pesoTotal;

            // Peso Líquido
            const voPesoLiquido = new PedidoItemPesoValueObject(pedidoItem.quantidade, pedidoItem.pesoLiquidoUnitario);
            pesoLiquido += voPesoLiquido.pesoTotal;
        });
        pesoBruto = toFixed(pesoBruto, 6);
        pesoLiquido = toFixed(pesoLiquido, 6);

        return {
            pesoBruto,
            pesoLiquido
        };
    }
}
